import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'app-library-search-field',
    imports: [MatFormField, ReactiveFormsModule, FormsModule, MatInput, IconComponent, MatPrefix, FromDictionaryPipe],
    templateUrl: './library-search-field.component.html',
    styleUrl: './library-search-field.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LibrarySearchFieldComponent implements AfterViewInit {
  initialQuery = input<string>('');

  fb = inject(FormBuilder);
  router = inject(Router);
  cd = inject(ChangeDetectorRef);

  searchForm = this.fb.group({
    query: this.fb.control<string>(''),
  });

  ngAfterViewInit(): void {
    this.searchForm.patchValue({ query: this.initialQuery() });
    this.cd.detectChanges();
  }

  onSubmit(): void {
    // go to external site in new tab
    window.open(
      'https://catalogus.coda-apeldoorn.nl/iguana/www.main.cls?surl=CA_Search#searchterm=' + this.searchForm?.value?.query,
      '_blank'
    );
  }
}
